import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchExportedBatch(organization_id, exported_batch_id) {
    return RequesterV1.get(
      `organization/production/query_by_provider/show_exported_batch/${organization_id}/fetch_exported_batch/${exported_batch_id}`
    );
  },
  fetchAgroExporterProcess(organization_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `organization/production/query_by_provider/show_exported_batch/${organization_id}/fetch_agro_exporter_process/${agro_exporter_process_id}`
    );
  }
};
